import React from "react";
import { Link } from "gatsby";
import "./LinksContainer.scss";
import { routes } from "@constants";

const LinksContainer = () => (
    <div className="footer-links">
        {routes.map((route, index) => {
            const { linkName, path } = route;

            return (
                <Link key={index} to={path} className="footer-links__link">
                    {linkName}
                </Link>
            );
        })}
    </div>
);

export default LinksContainer;
